<template>
    <y-row
        v-if="content"
        class="c-landing-hero"
    >
        <y-col :md="col1">
            <div class="c-landing-hero__content-wrapper">
                <h2
                    v-if="content.title"
                    class="c-landing-hero__title"
                    v-html="heroTitle(content.title)"
                />

                <p
                    v-if="content.synopsis"
                    class="c-landing-hero__synopsis"
                >
                    {{ content.synopsis }}
                </p>

                <div class="c-landing-hero__buttons-wrapper">
                    <y-button
                        v-if="scheduleDemo"
                        flat
                        tag="router-link"
                        :to="{name: 'schedule-demo'}"
                        color="primary"
                        class="ml-5 mb-2"
                    >
                        {{ $t('general.request_demo') }}
                    </y-button>
                    <y-button
                        v-if="content.custom && content.custom['button-link']"
                        flat
                        :tag="isLink(content.custom['button-link']) ? 'a' : 'router-link'"
                        bordered
                        class="mb-2"
                        color="white"
                        :href="content.custom['button-link']"
                        :to="content.custom['button-link']"
                    >
                        {{ content.custom['button-title'] }}
                    </y-button>
                </div>
            </div>
        </y-col>

        <y-col :md="col2">
            <div class="c-landing-hero__image-wrapper">
                <img
                    v-if="content.image"
                    class="c-landing-hero__image"
                    :src="imgSrc(content.image)"
                    :alt="content.title"
                >
            </div>
        </y-col>
    </y-row>
</template>

<script>
    import { isLink } from '@/helpers/helpers';

    export default {
        name: 'LandingHero',

        props: {
            content     : Object,
            targetWord  : String,
            scheduleDemo: Boolean,
            col1        : {
                type   : [String, Number],
                default: '6',
            },
            col2: {
                type   : [String, Number],
                default: '6',
            },
            noAnimation: Boolean,
        },

        methods: {
            isLink,
            /**
             * Return title of hero
             *
             * @param {string} title
             * @returns {*}
             */
            heroTitle(title) {
                const list = this.content?.custom?.words.split('\n').map((word) => `<span class="${this.noAnimation ? 'c-landing-hero__title__replace-word' : 'c-landing-hero__title__replace-word--animation'}">${word}</span>`);
                return title.replace(this.targetWord, `<span class="c-landing-hero__title__replace-word-list">${list.join(' ')}</span>`);
            },
        },
    };
</script>

<style lang="scss" src="./index.scss" />
